// ----------------------------------------------------------------------------
// Nombre del Programa : Login
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el inicio de sesion de el usuario
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------


import { Row, Col, Button } from 'react-bootstrap';
import './Home.scss';

import { useEffect, useState } from 'react';
import { GoogleOAuthProvider,useGoogleLogin } from '@react-oauth/google';
import axios, { AxiosRequestHeaders } from 'axios';
import { setToken, setRoli, setUsuarioi, getApiCliGoo } from '../../Utilidades/session';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { login, logout } from '../../stores/AuthUser';
import { refreshTokenSetup } from '../../Utilidades/refreshToken';
import { StatusAlertService } from 'react-status-alert';
import { getPermisosUsuario } from '../../Services/UsuariosService';
import { authInitialized } from '../../stores/App';
import { getConfiguraciones } from '../../Services/EnlacesService';
import { getToken } from '../../Utilidades/session';
import { loginSetup } from '../../Utilidades/interceptorLogin';

export const Login = () => {

    var clientId: string = String(getApiCliGoo() || '');
    const dispatch = useDispatch();
    const iniciado = useSelector((state: any) => state.authUser.loggedIn);
    const navigate = useNavigate();
    const [validoSesion, setvalidoSesion] = useState<boolean>(false);
    const redi = useSelector((state: any) => state.authUser.redi);



    const [urlImagen, setUrlImagen] = useState('');


    useEffect(() => {
        cargaConfiguraciones();
    }, []);


    const cargaConfiguraciones = async () => {
        const response: any = await getConfiguraciones().catch(() => {
            setUrlImagen("")
        });
        if (response.data && response.data.data) {
            setUrlImagen(response.data.data[0].urladjunto);
        }
        let token = getToken()
        if(token){
            await loginSetup(token,setvalidoSesion,dispatch);
        }
    };


    const onSuccess = (res: any) => {
        // console.log('success:', res.profileObj);
        //console.log('success:', res);
        //dispatch(token(res.tokenObj));
        setvalidoSesion(true)
        refreshTokenSetup(res);
        const restProfile : any = {};
        setToken(res.access_token);
        if (!!res.access_token) {
                    axios.get(
                            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${res.access_token}`,
                        {
                    headers: {
                        Authorization: `Bearer ${res.access_token}`,
                        Accept: 'application/json',
                    },
                }
            )
            .then((resProfile : any) => {
                restProfile.name = resProfile.data.name;
                //state.token = action.payload.accessToken;
                restProfile.imageUrl = resProfile.data.picture;
                restProfile.googleId = resProfile.data.id;
                restProfile.email = resProfile.data.email;
            })
            .catch((err) => console.log('err: ', err));
        }
        getPermisosUsuario(res.googleId)
            .then((response) => {
                if (
                    response.data?.data.length &&
                    response.data?.data[0].tiporol_id?.pantallas?.length
                ) {
                    setRoli(response.data.data[0].tiporol_id.tiporol_id);
                    setUsuarioi(response.data.data[0].usuario_id);

                    const data = {
                        ...restProfile,
                        usuarioId: response.data.data[0].usuario_id,
                        pantallas: response.data.data[0].tiporol_id.pantallas.filter(
                            (p) => p.selected
                        ),
                    };

                    dispatch(login(data));
                    dispatch(authInitialized());

                    //Modificacion: Marca de Inicio WII C-24-1229-24
                    if (redi != null && redi != '') {
                        navigate(redi || "/", { replace: false });
                    }


                }
                else if (
                    response.data?.data.length &&
                    response.data?.data[0].invitado == 1
                ) {
                    setRoli("");
                    setUsuarioi("");

                    const data = {
                        ...restProfile,
                        usuarioId: 0,
                        pantallas: [],
                    };

                    dispatch(login(data));
                    dispatch(authInitialized());

                    if (redi != null && redi != '') {
                        navigate(redi || "/", { replace: false });
                    }
                    //Modificacion: Marca de Fin WII C-24-1229-24

                }
                else {
                    const err = response as any;
                    const msg =
                        err.response.data?.meta.message ||
                        err.response.data?.meta.status ||
                        err.message;

                    StatusAlertService.showError(msg);
                    setToken('');
                    dispatch(logout());
                }
            })
            .catch((err) => {
                setToken('');
                dispatch(logout());
                dispatch(authInitialized());
            });
    };
    const onFailure = (err: any) => {
        setvalidoSesion(true)
        setToken('');
        dispatch(logout());
        dispatch(authInitialized());
    };
    const logOut = () => {
        setvalidoSesion(true)
        setToken('');
        dispatch(logout());
        navigate('/', { replace: true });
    };

    const WebLogin = () => {
        const login = useGoogleLogin({
          onSuccess: async (tokenResponse : any) => {

            //localStorage.setItem('googleUser', JSON.stringify(tokenResponse));
            //setUser(tokenResponse);


            const userInfo = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
            }).then(res => res.data);
            tokenResponse.googleId = userInfo.sub;
            onSuccess(tokenResponse);
          },
          onError: (error) => {
            logOut();
          },
          prompt: 'select_account'
          //flow: 'auth-code', // Optional: Use for server-side auth
        });
        return (
            
            <Button className='button-login'
                onClick={() => login()}
                variant="primary"
            >
                <div className="material-icons">account_circle</div>
                {'Iniciar Sesión'}
            </Button>
        );
    };

    return (
        <>
            <div className="heigth102">
                <Row className="heigth102">
                    <Col className="login-imagen" sm={5} style={{ background: `url('${urlImagen}')` }}>
                    </Col>
                    {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
                    <Col className="login-separador" sm={1}>
                    </Col>
                    {/*Modificacion: Marca de Fin WII C-24-1229-24*/}
                    <Col className="cuerp-login" sm={5}>
                        <Row className="mt-5 titulo-login">
                            <Col className="textotitulo-login">ProsaWeb</Col>
                        </Row>
                        <Row className="titulo mt-2">
                            <hr className="linearoja-login mt-3" />
                        </Row>
                        <Row className="mt-2 titulo-login">
                            <Col className="textosubtitulo-login">Ingreso al sistema</Col>
                        </Row>
                        <Row className="mt-4 titulo-login">
                            <GoogleOAuthProvider clientId={clientId} >
                                <WebLogin />
                            </GoogleOAuthProvider>
                        </Row>
                    </Col>
                    <Col sm={1}>
                    </Col>
                </Row>
            </div>
        </>
    );
};